import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, Ref } from 'vue';
import { BoundedTextElement, CanvasElement } from '@/typings/customilyElements/canvasElements';
import { ValueFormat, SourceValueFormatOptions, MAP_VALUE_FORMATS, ElementType } from '@/typings/designStudio/sourceElementTypes';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';
import CSelect from '@/components/shared/CSelect/CSelect.vue';
import { CSelectItem } from '../shared/CSelect';
import { getElementType } from '@/utils/elementTypeUtils';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import { getCanvasElementIcon } from '@/utils/elementsUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementsLinkModal',
  props: {
    targetElement: null,
    sourceElements: null
  },
  emits: ["applyLink", "close", "unlink"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'applyLink', payload: { sourceElement: CanvasElement; sourceType: ElementType; valueFormat: ValueFormat }): void;
    (event: 'close'): void;
    (event: 'unlink'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    targetElement: BoundedTextElement;
    sourceElements: CanvasElement[];
};





const selectedSource: Ref<CSelectItem<string> | undefined> = ref();
const selectedValueFormat: Ref<CSelectItem<ValueFormat> | undefined> = ref();
    
const sources = computed(() =>
    props.sourceElements
        .filter(e => typeof e.uuid === 'string' && e.uuid.length > 0)
        .map(e => ({
            label: e.name ?? '',
            value: e.uuid as string
        }))
);

const valueFormats = computed(() => {
    const source = props.sourceElements.find(e => e.uuid === selectedSource.value?.value);
    if (!source) {
        return [];
    }
    const sourceType = getElementType(source);
    if (sourceType === ElementType.Map) {
        return SourceValueFormatOptions.filter(opt =>
            MAP_VALUE_FORMATS.includes(opt.value)
        );
    }
    return [];
});

watch(
    () => props.targetElement.sourceElement,
    (newVal) => {
        if (newVal) {
            const sourceMatch = sources.value.find(opt => opt.value === newVal.sourceId);
            selectedSource.value = sourceMatch ? sourceMatch : undefined;

            const valueFormatMatch = valueFormats.value.find(opt => opt.value === newVal.valueFormat);
            selectedValueFormat.value = valueFormatMatch ? valueFormatMatch : undefined;
        }
    },
    { immediate: true }
);

watch(selectedSource, (newVal) => {
    if (!newVal) {
        selectedValueFormat.value = undefined;
    }
});

watch(
  () => sources.value,
  (newSources) => {
    if (!newSources || newSources.length === 0) {
      selectedSource.value = undefined;
      return;
    }
    const found = newSources.find(opt => opt.value === selectedSource.value?.value);
    if (!found) {     
      selectedSource.value = newSources[0];
    }
  },
  { immediate: true }
);

watch(
  () => valueFormats.value,
  (newValueFormats) => {
    if (!newValueFormats || newValueFormats.length === 0) {
      selectedValueFormat.value = undefined;
      return;
    }
    const found = newValueFormats.find(opt => opt.value === selectedValueFormat.value?.value);
    if (!found) {     
      selectedValueFormat.value = newValueFormats[0];
    }
  },
  { immediate: true }
);

const targetIcon = computed(() => getCanvasElementIcon(props.targetElement) || '');

const getSourceIcon = (uuid: string | undefined) => {
    if (!uuid) return '';
    const element = props.sourceElements.find(e => e.uuid === uuid);
    if (!element) return '';
    return getCanvasElementIcon(element) || '';
};

const getSourceId = (uuid: string | undefined) => {
    if (!uuid) return '';
    const element = props.sourceElements.find(e => e.uuid === uuid);
    return element?.id ?? '';
};

const closeModal = () => emit('close');
const onConfirmHandler = () => {
    if (!selectedSource.value || !selectedValueFormat.value) {
        return;
    }
    const sourceElement = props.sourceElements.find(e => e.uuid === selectedSource.value?.value);
    if(!sourceElement) {
        return;
    }
    const sourceType = getElementType(sourceElement);
    if(!sourceType) {
        return;
    }
    emit('applyLink', {
        sourceElement: sourceElement,
        valueFormat: selectedValueFormat.value?.value,
        sourceType: sourceType
    });
};

const onUnlinkHandler = () => {
    emit('unlink');
};

const canApplyLink = computed(() =>
    !!selectedSource.value && !!selectedValueFormat.value
);

return { __sfc: true,props, emit, selectedSource, selectedValueFormat, sources, valueFormats, targetIcon, getSourceIcon, getSourceId, closeModal, onConfirmHandler, onUnlinkHandler, canApplyLink, CModal, CButton, CSelect, SvgIcon }
}

})